import { AUTH_API_ENDPOINTS } from "@/features/auth/config/authApiPath";
import { authStorageService } from "@/features/auth/services/storage.service";
import { fetcherWithout401Retry } from "@/shared/lib/fetcher.client";

type GenerateResponse = { login_token: string, expires_in: number };
type ExchangeResponse = { access_token: string, token_type: string, expires_in: number };

export const generateCrossScopeToken = async (): Promise<GenerateResponse> => {
  const response = await fetcherWithout401Retry.post<GenerateResponse>(
    AUTH_API_ENDPOINTS.GENERATE_CROSS_SCOPE_TOKEN,
    {},
  );

  return response.data;
};

export const exchangeCrossScopeToken = async (loginToken: string): Promise<ExchangeResponse> => {
  const response = await fetcherWithout401Retry.post<ExchangeResponse>(
    AUTH_API_ENDPOINTS.EXCHANGE_CROSS_SCOPE_TOKEN,
    {
      login_token: loginToken,
      direction: "to_employee",
      device_id: authStorageService.getAuthDeviceId(),
    },
  );

  authStorageService.deleteAuthToken();
  authStorageService.saveAuthToken(response.data.access_token, response.data.expires_in);
  return response.data;
};
